<template lang="pug">
    section#citacao
        blockquote
            p "{{ content[ativo].citacao }}"
            cite {{ content[ativo].autor }}
        SvgIcon(data="@svgs/logos/arvore.svg")
</template>

<script>
export default {
    name: "component-citacao",
    props: {
        content: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            ativo: 0,
            interval: null
        }
    },
    mounted() {
        this.interval = setInterval(() => {
            this.toggleCitacao(this.ativo + 1)
        }, 25000)
    },
    methods: {
        toggleCitacao(index) {
            if (index >= this.content.length)
                this.ativo = 0
            else
                this.ativo = index
        },
    },
}
</script>

<style lang="stylus" scoped src="./Citacao.styl"></style>
